import { CdkDropList } from "@angular/cdk/drag-drop";

import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, ChangeDetectionStrategy } from "@angular/core";
import { FormControl, FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NgbPopover } from "@ng-bootstrap/ng-bootstrap";
import { MultipleIndicatorNamePipe } from "config/pipes/multiple-indicator-name.pipe";
import { AppendWithDirective } from "rl-common/components/char-data/directives/append-with.directive";
import { ChipComponent } from "rl-common/components/chip/chip.component";
import { NoRecordsFoundComponent } from "rl-common/components/no-records-found/no-records-found.component";
import { LoaderComponent } from "rl-common/components/panel/loader/loader.component";
import { TextInputComponent } from "rl-common/components/text/text-input/text-input.component";
import { ITemplateCharacteristicGroup } from "rl-common/models/i-template-characteristic-group";
import { CharDataTypeNamePipe } from "rl-common/pipes/char-data-type-name.pipe";
import { CharTypeNamePipe } from "rl-common/pipes/char-type-name.pipe";
import { ISourceField } from "rl-common/services/entity-config/entity-config.models";
import { Subscription } from "rxjs";

@Component({
	selector: "rl-select-template-source-field",
	templateUrl: "./select-template-source-field.component.html",
	styleUrls: ["./select-template-source-field.component.scss"],
	changeDetection: ChangeDetectionStrategy.Eager,
	imports: [CdkDropList, NgbPopover, ChipComponent, LoaderComponent, CharTypeNamePipe, CharDataTypeNamePipe, MultipleIndicatorNamePipe, NoRecordsFoundComponent, FormsModule, ReactiveFormsModule, TextInputComponent, AppendWithDirective]
})
export class SelectTemplateSourceFieldComponent implements OnInit, OnChanges, OnDestroy {

	@Input()
	group: ITemplateCharacteristicGroup;

	@Input()
	cmd: ISourceField[];

	@Input()
	sourceFieldsLoaded: boolean;

	@Input()
	charTypeName: string;

	@Output()
	onComplete = new EventEmitter<Set<number>>();

	@Output()
	selectionChange = new EventEmitter<Set<number>>();

	fieldsToAdd = new Set<number>();
	searchControl = new FormControl("");
	filteredFields: ISourceField[] = [];

	private readonly _subs: Subscription[] = [];

	constructor() { }

	ngOnInit(): void {
		this.applySearch();
		const sub = this.searchControl.valueChanges.subscribe(() => this.applySearch());
		this._subs.push(sub);
	}

	ngOnChanges(): void {
		this.applySearch();
	}

	ngOnDestroy(): void {
		this._subs.forEach(sub => sub.unsubscribe());
	}

	applySearch() {
		const keywords = (this.searchControl.value ?? "").toLowerCase().trim();
		const fields = this.cmd ?? [];
		this.filteredFields = keywords ? fields.filter(f =>
			f.sourceFieldID.toString().includes(keywords) ||
			f.sourceFieldName?.toLowerCase().includes(keywords) ||
			f.mergeTag?.toLowerCase().includes(keywords)
		) : fields;
	}

	clearSearch() {
		this.searchControl.setValue("");
	}

	toggleSourceField(sourceFieldId: number) {
		if (this.fieldsToAdd.has(sourceFieldId)) {
			this.fieldsToAdd.delete(sourceFieldId);
		} else {
			this.fieldsToAdd.add(sourceFieldId);
		}
		this.selectionChange.emit(new Set(this.fieldsToAdd));
	}

	submit() {
		this.onComplete.emit(this.fieldsToAdd);
	}

	getSourceFieldById(id: number) {
		const sourceField = this.cmd.find(({ sourceFieldID }) => sourceFieldID === id);
		return sourceField.sourceFieldName;
	}

	isChecked(sourceFieldId: number) {
		return this.fieldsToAdd.has(sourceFieldId) ? true : false;
	}

}

